import { Navigate, Route, Routes } from "react-router-dom"
import AdminLayout from "./components/admin/AdminLayout"
import AdminFeatureFlagsModal from "./components/admin/AdminFeatureFlagsModal"
import { AdminSecretTapProvider } from "./context/AdminSecretTapContext"
import { useFeatureFlags } from "./context/FeatureFlagsProvider"
import { useSecretFeatureFlagsModal } from "./hooks/useSecretFeatureFlagsModal"
import AdminLogin from "./pages/admin/AdminLogin"
import AdminOverview from "./pages/admin/AdminOverview"
import AdminEvents from "./pages/admin/AdminEvents"
import AdminLocations from "./pages/admin/AdminLocations"
import AdminGiving from "./pages/admin/AdminGiving"
import AdminMessage from "./pages/admin/AdminMessage"
import AdminPrayerRequests from "./pages/admin/AdminPrayerRequests"
import AdminWeeklyDeclaration from "./pages/admin/AdminWeeklyDeclaration"
import AdminHeroSlides from "./pages/admin/AdminHeroSlides"
import AdminAnnouncements from "./pages/admin/AdminAnnouncements"
import AdminUpload from "./pages/admin/AdminUpload"
import AdminSermons from "./pages/admin/AdminSermons"
import ChapterIntakeUploadPage from "./pages/ChapterIntakeUploadPage"

/** Admin CMS — served only on the admin subdomain (e.g. admin.dominioncity.ie). */
const AdminApp = () => {
  const { flags } = useFeatureFlags()
  const { open, closeModal, handleSecretTap } = useSecretFeatureFlagsModal()

  return (
    <AdminSecretTapProvider onSecretTap={handleSecretTap}>
      <Routes>
        <Route path="login" element={<AdminLogin />} />
        <Route path="chapter-intake" element={<ChapterIntakeUploadPage />} />
        <Route path="chapter-intake/upload" element={<ChapterIntakeUploadPage />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<AdminOverview />} />
          <Route path="events" element={<AdminEvents />} />
          <Route path="sermons" element={<AdminSermons />} />
          <Route path="locations" element={<AdminLocations />} />
          <Route path="giving" element={<AdminGiving />} />
          <Route path="message" element={<AdminMessage />} />
          <Route path="weekly-declaration" element={<AdminWeeklyDeclaration />} />
          <Route path="hero-slides" element={<AdminHeroSlides />} />
          {flags.announcements && <Route path="announcements" element={<AdminAnnouncements />} />}
          <Route path="prayer-requests" element={<AdminPrayerRequests />} />
          <Route path="upload" element={<AdminUpload />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>

      <AdminFeatureFlagsModal open={open} onClose={closeModal} />
    </AdminSecretTapProvider>
  )
}

export default AdminApp
